// Asynchronous order exports. A download button POSTs the current filter form
// (tab + _search[...]) plus its report_type to the order_management downloads
// endpoint, then polls for the generated file and downloads it when ready.
//
// Buttons opt in with data attributes:
//   data-order-export        marker
//   data-report-type         driver_deliveries | pick_up_delivery | all | status_envelopes
//   data-form (optional)     CSS selector of the filter form to serialize
//                            (omitted for status_envelopes, which ignores filters)

const POLL_INTERVAL_MS = 3000;
const POLL_CAP_MS = 5 * 60 * 1000; // 5 minute client cap
const MESSAGES = {
  failed: "Der opstod en fejl under generering af eksporten. Prøv igen.",
  stillProcessing: "Eksporten genereres stadig – prøv igen om lidt."
};

let initOrdersDownload = () => {
  $("[data-order-export]").each(function () {
    $(this)
      .off("click.ordersDownload")
      .on("click.ordersDownload", (e) => {
        e.preventDefault();
        const button = $(e.currentTarget);
        if (button.data("downloading")) return;
        startOrderExport(button);
      });
  });
};

let startOrderExport = (button) => {
  setButtonLoading(button, true);

  const reportType = button.data("report-type");
  const formSelector = button.data("form");
  let data = "report_type=" + encodeURIComponent(reportType);
  if (formSelector && $(formSelector).length) {
    data += "&" + $(formSelector).serialize();
  }

  $.ajax({
    url: "/order_management/downloads",
    method: "POST",
    data: data,
    dataType: "json",
    beforeSend: (jqXHR) => {
      jqXHR.setRequestHeader("X-CSRF-Token", $('meta[name="csrf-token"]').attr("content"));
    },
    success: (response) => {
      if (response.status === "ok") {
        const deadline = Date.now() + POLL_CAP_MS;
        setTimeout(() => pollOrderExport(button, response.token, deadline), 2000);
      } else {
        finishOrderExport(button);
        showOrderExportAlert("danger", MESSAGES.failed);
      }
    },
    error: () => {
      finishOrderExport(button);
      showOrderExportAlert("danger", MESSAGES.failed);
    }
  });
};

let pollOrderExport = (button, token, deadline) => {
  $.ajax({
    url: `/order_management/downloads/${token}`,
    method: "GET",
    dataType: "json",
    success: (response) => {
      if (response.status === "ready") {
        finishOrderExport(button);
        triggerDownload(response.url);
      } else if (response.status === "failed") {
        finishOrderExport(button);
        showOrderExportAlert("danger", MESSAGES.failed);
      } else {
        // still processing
        if (Date.now() >= deadline) {
          finishOrderExport(button);
          showOrderExportAlert("info", MESSAGES.stillProcessing);
        } else {
          setTimeout(() => pollOrderExport(button, token, deadline), POLL_INTERVAL_MS);
        }
      }
    },
    error: () => {
      finishOrderExport(button);
      showOrderExportAlert("danger", MESSAGES.failed);
    }
  });
};

let setButtonLoading = (button, loading) => {
  button.data("downloading", loading);
  // Hide the button's label (icon and/or text) while the spinner shows.
  button.children().not(".spinner").toggle(!loading);
  button.find(".spinner").toggle(loading);
};

let finishOrderExport = (button) => {
  setButtonLoading(button, false);
};

let triggerDownload = (url) => {
  const anchor = document.createElement("a");
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

let showOrderExportAlert = (type, message) => {
  const container = $(".flash");
  const alert = $(`<div class="col alert alert-${type}"></div>`).text(message);
  container.append(alert);
  setTimeout(() => alert.fadeOut(400, () => alert.remove()), 8000);
};

$(function () {
  initOrdersDownload();
});
